module.exports = __webpack_public_path__ + "static/img/FreeBuds3.6e28db7b.jpg";